import type { ExtraRatesStore } from './interfaces'

export const getters = {
  isLoading: (state: ExtraRatesStore): ExtraRatesStore['loading'] => state.loading,
  isSaving: (state: ExtraRatesStore): ExtraRatesStore['saving'] => state.saving,
  getDaysOfWeek: (state: ExtraRatesStore): ExtraRatesStore['daysOfWeek'] => state.daysOfWeek,
  getTabId: (state: ExtraRatesStore): ExtraRatesStore['tabId'] => state.tabId,
}
